import React, { PropsWithChildren, useMemo } from "react";
import { BoxProps, AHTeamIconCircle, ListItem, Box, ListItemProps } from "arkh";
import { Section } from "../State/Routine/types";
import { getSectionTitle } from "../getSectionTitle";
import { useIntl } from "react-intl";

export function SectionSelectItem({
  isFirst,
  isLast,
  section,
  selected,
  onChange,
  children,
}: PropsWithChildren<
  {
    isFirst: boolean;
    isLast: boolean;
    section: Section;
    selected?: boolean;
    onChange: (selected: boolean) => void;
  } & BoxProps
>) {
  return (
    <BasicSectionListItem
      isFirst={isFirst}
      isLast={isLast}
      onPress={() => {
        onChange(!selected);
      }}
      minHeight={children ? 80 : undefined}
      right={
        <>
          {children}
          <Box spaceLeft="medium" />
          <ListItem.MultiSelectIndicator selected={!!selected} />
        </>
      }
      section={section}
    />
  );
}

export function BasicSectionListItem(
  props: ListItemProps & { section: Section }
) {
  const { section, ...listProps } = props;
  const title = useMemo(() => getSectionTitle(section), [section]);

  const intl = useIntl();
  const placeholder = intl.formatMessage({
    defaultMessage: "Section name",
    description: "SectionSelectItem section name placeholder",
  });
  const hasPlaceholder = title === "";
  return (
    <ListItem
      {...listProps}
      border="border-primary"
      left={
        section.assignedTeam ? (
          <AHTeamIconCircle
            size="smallMedium"
            color={section.assignedTeam.color}
            type={section.assignedTeam.icon}
            isPrivate={section.assignedTeam.isPrivate}
          />
        ) : undefined
      }
    >
      <ListItem.Title color={hasPlaceholder ? "text-washed" : undefined}>
        {hasPlaceholder ? placeholder : title}
      </ListItem.Title>
    </ListItem>
  );
}
